<script setup>
import {useDebounceFn} from "@vueuse/core";
import {inject,} from "vue";
import {useI18n} from "vue-i18n";
import Group from "@/Components/Input/Group.vue";
import {anyBlank} from "@/utilities";

const route = inject("route");
const {t} = useI18n();

const props = defineProps({
  form: Object
});

const fillAddress = () => {
  if (anyBlank(props.form.billing_address.postcode, props.form.billing_address.street_number)) {
    return;
  }
  props.form.errors = {};
  window.axios
      .get(
          route("api.address-check.index", {
            postcode: props.form.billing_address.postcode,
            street_number: props.form.billing_address.street_number,
          })
      )
      .then(function (response) {
        props.form.billing_address.postcode = response.data.data.postcode;
        props.form.billing_address.street_number = response.data.data.street_number;
        props.form.billing_address.street_name = response.data.data.street_name;
        props.form.billing_address.city = response.data.data.city;
        props.form.billing_address.country = "NL";
        props.form.billing_address.longitude = response.data.data.longitude;
        props.form.billing_address.latitude = response.data.data.latitude;
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 404) {
            props.form.errors.billing_address = {
              postcode: [t("Was unable to find an address with this postcode and street number")],
            };
          }
        }
      });
};

function fillAddressDebounce() {
  useDebounceFn(fillAddress, 800)();
}

</script>

<template>
    <FormKit
        v-model="form.billing_address_same_as_shipping_address"
        :errors="form.errors?.billing_address_same_as_shipping_address"
        :label="$t('Shipping address same as billing address')"
        :value="form.billing_address_same_as_shipping_address"
        name="billing_address_same_as_shipping_address"
        type="checkbox"
    />


    <template v-if="!form.billing_address_same_as_shipping_address">
        <Group cols="4">
            <FormKit
                v-model="form.billing_address.postcode"
                :classes="{ outer: 'col-span-2' }"
                :errors="form.errors?.billing_address?.postcode"
                :label="$t('Postcode')"
                :value="form.billing_address.postcode"
                name="billing_address.postcode"
                type="text"
                @input="fillAddressDebounce"
            />

            <FormKit
                v-model="form.billing_address.street_number"
                :errors="form.errors?.billing_address?.street_number"
                :label="$t('Street number')"
                :value="form.billing_address.street_number"
                name="billing_address.street_number"
                type="text"
                @input="fillAddressDebounce"
            />

            <FormKit
                v-model="form.billing_address.street_number_addition"
                :errors="form.errors?.billing_address?.street_number_addition"
                :label="$t('Street number addition')"
                :value="form.billing_address.street_number_addition"
                name="billing_address.street_number_addition"
                type="text"
            />
        </Group>

        <FormKit
            v-model="form.billing_address.street_name"
            :errors="form.errors?.billing_address?.street_name"
            :label="$t('Street name')"
            :value="form.billing_address.street_name"
            name="billing_address.street_name"
            type="text"
        />

        <FormKit
            v-model="form.billing_address.city"
            :errors="form.errors?.billing_address?.city"
            :label="$t('City')"
            :value="form.billing_address.city"
            name="billing_address.city"
            type="text"
        />
    </template>
</template>
